import React, { useState, useContext, useRef } from "react";
import { AppBar, Menu, MenuItem, Toolbar } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { makeStyles } from "tss-react/mui";
import Context from '../../context'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import TextLabel from "../TextLabel";
import { useGetToken } from "../../hooks/useGetToken";
import { logUserAction } from "../../utils/apiUtils";
import { CONSTANTS } from "../../CONSTANTS";
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import axios from "axios";
import { useGlobalStateContext } from "../../context/globalState";

const useStyles = makeStyles()((theme) => ({
    root: {
        backgroundColor: "#e8eaf6",
        top: 0,
        width: "100%",
        opacity: 1,
        flex: 1,
    },
    header: {
        top: "0px",
        left: "0px",
        height: "50px",
        background: "#FFFFFF 0% 0% no-repeat padding-box",
        boxShadow: "0px 3px 6px #00000029",
        opacity: 1,
        marginTop: "5px",
    },
    headerInfo: {
        top: "17px",
        left: "94px",
        width: "148px",
        height: "30px",
        fontFamily: "Inter",
        fontWeight: 600,
        fontSize: "18px",
        lineHeight: "21px",
        letterSpacing: "0px",
        textAlign: "center",
        color: "#3D3D3D",
        opacity: 1,
        marginLeft: theme.spacing(1),
    },
}));

type PassportPageHeaderProps = {
    onSignOut: () => void; // Function to handle sign out
};

const PassportPageHeader: React.FC<PassportPageHeaderProps> = ({onSignOut}) => {
    const {
        authState: { user },
    } = useContext(Context)
    const { classes } = useStyles(); 
    const [showSignOut, setShowSignOut] = useState(false);
    const [getToken] = useGetToken();
    const userMenuRef = useRef<HTMLDivElement>(null);
    const { isAgreed, setIsAgreed, isReview, setIsReview } = useGlobalStateContext();

   
    const navigate = useNavigate();
    const { t } = useTranslation()

    const handleSignOut = async () => {
        const token = await getToken();
        logUserAction(token, user?.username || '', CONSTANTS.USER_ACTION.LOGOUT)
        onSignOut(); // Call the onSignOut function passed as a prop
        navigate('/SignOut')
    };
  
    const handlePrivacyStatementClick = async () => {
        const token = await getToken();
        const config = { headers: { Authorization: token } };
    
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_ENDPOINT}/v1/getUserConsent?userId=${user?.username}`,
            config
          );
    
          const consentGiven = response.data?.consentGiven || false;
    
          // Update global state
          setIsReview(true);
          setIsAgreed(consentGiven);
    
          // Navigate to the Terms and Conditions page
          navigate("/terms");
        } catch (error) {
          console.error("Error fetching consent status:", error);
    
          // Update global state in case of error
          setIsReview(true);
          setIsAgreed(false);
    
          // Navigate to the Terms and Conditions page
          navigate("/terms");
        }
      };
    return (
        <div className={classes.header}>
            <AppBar position="static" color='inherit'>
                <Toolbar>
                    <img src="/icon_kone_logo.jpg" alt="loading" style={{ marginRight: '1vw'}} />
                    <TextLabel type='title' sxStyles={{flexGrow:1}}>
                        {t('passportPage.title')}
                    </TextLabel>
                    <div style={{ display: "flex" }} ref={userMenuRef}>
                    <img
                        src="/icon_user.jpg"
                        style={{
                            objectFit: "contain",
                            marginLeft: "8px",
                            marginRight: "8px",
                        }}
                    />
                    <TextLabel type={'regularText'} variant='body2'>{user?.name?.split(' ')[1] || t('passportPage.labels.guest')}</TextLabel>
                    <KeyboardArrowDownIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowSignOut(!showSignOut)}
                    />
                     
                     <Menu
                    anchorEl={userMenuRef.current}
                    open={showSignOut}
                    onClose={() => setShowSignOut(false)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                     <MenuItem onClick={handlePrivacyStatementClick}>
                    <PrivacyTipIcon fontSize="small" style={{ marginRight: '8px' }} />
                    {t('passportPage.privacyStatements.privacyStatement')}
                </MenuItem>
                <MenuItem onClick={handleSignOut}>
                                {t('settings.signOut')}
                            </MenuItem>
                </Menu>
                    </div>
                </Toolbar>
            </AppBar>
           
        </div>
    );
};

export default PassportPageHeader;
